function toggleContent(event) {
  event.currentTarget.classList.toggle("accordion__title--open");
}

function initAccordion() {
  const accordions = document.querySelectorAll(".accordion__title");
  [...accordions].forEach((accordion) =>
    accordion.addEventListener("click", toggleContent),
  );
}

initAccordion();
